import axiosInstance from '../axiosInterceptor/axiosInstance'

const createCompetitionChannel = async ({ orgId, competitionId }) => {
  const url = `/orgs/${orgId}/channels/competitions/${competitionId}`
  const response = await axiosInstance.post(url)
  return response?.data
}

export default createCompetitionChannel
